import React from "react";

const ProfesorCard = ({ profesor }) => {
  return (
    <article className=" h-[300px] xl:w-full xl:h-[400px] bg-white rounded-lg rounded-tl-none overflow-hidden group relative duration-300 outline  outline-primario shadow-custom-first">
      <div className="absolute w-32 h-32 xl:w-[200px] xl:h-[200px] rounded-full z-0 transition-all left-1/2 -translate-x-1/2 top-[10%] scale-0 bg-primario group-hover:motion-safe:scale-[85%] duration-300 ease-in-out"></div>
      <div className="absolute rounded-full w-32 h-32 xl:w-[200px] xl:h-[200px] z-10 bg-primario transition-all left-1/2 -translate-x-1/2 top-[10%] group-hover:motion-safe:scale-75 group-hover:motion-safe:border-8 border-white duration-500 ease-in-out overflow-hidden">
        <img
          src={profesor.imagen}
          alt={profesor.nombre}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <p className="absolute bottom-[30%] xl:bottom-[25%] transform left-1/2 -translate-x-1/2 w-max text-2xl xl:text-2xl font-bold text-primario">
        {profesor.nombre}
      </p>
      <p className="absolute bottom-[18%] xl:bottom-[18%] transform left-1/2 -translate-x-1/2 w-min font-bold font-Bebas tracking-wide text-xl text-blue-6">
        {profesor.cargo}
      </p>
      <div className="absolute transition-all bottom-0 translate-y-full group-hover:motion-safe:translate-y-0 w-full h-[50px] bg-primario duration-500 ease-in-out flex flex-row text-white text-3xl justify-evenly items-center">
        {profesor.redes.facebook && (
          <a
            href={profesor.redes.facebook}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-facebook-f hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
          </a>
        )}
        {profesor.redes.mail && (
          <a
            href={profesor.redes.mail}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-solid fa-envelope hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
          </a>
        )}
        {profesor.redes.instagram && (
          <a
            href={profesor.redes.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-instagram hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
          </a>
        )}
      </div>
    </article>
  );
};

export default ProfesorCard;
